// extracted by mini-css-extract-plugin
export default {"text_container":"register-page_text_container__+-EAS","button_reset":"register-page_button_reset__GS6Je"};